// Petite machine d'état pure pour la disponibilité des agents et la capture
// d'e-mail associée. Isolée de App.tsx pour rester testable sans DOM/fetch.

export type AvailabilityState = 'unknown' | 'online' | 'offline';
export type AiMode = 'auto' | 'off';

export type AvailabilityResponse = {
  online: boolean;
  message: string;
  aiMode: AiMode;
};

export function toAvailabilityState(online: boolean): AvailabilityState {
  return online ? 'online' : 'offline';
}

/**
 * Tant que l'agent n'est pas disponible et que le visiteur n'a pas encore
 * donné son e-mail, l'envoi d'un (premier) message doit être bloqué en
 * attendant la capture (contrat 2.2 : "hors ligne").
 */
export function isSendBlocked(state: {
  availability: AvailabilityState;
  emailCaptured: boolean;
}): boolean {
  return state.availability === 'offline' && !state.emailCaptured;
}

/**
 * En ligne, si aucun agent ne répond sous 120s après le premier message
 * visiteur, on propose (sans bloquer) de laisser un e-mail. Ne s'applique
 * plus une fois l'e-mail capturé.
 */
export function shouldOfferSoftInvite(state: {
  availability: AvailabilityState;
  emailCaptured: boolean;
}): boolean {
  return state.availability === 'online' && !state.emailCaptured;
}
